import { uploadBytesResumable as upload, getDownloadURL as downloadURL } from 'firebase/storage';
import { matchPath } from 'react-router-dom';
import { message } from 'antd';
import { uuid } from '../utils/comm';
import { reportExternalOperation } from '../api/audit';
import pages from '../permissions/external-audit-pages.json';

const uploadPages = new Map();
const objectKey = reference => `${reference.bucket}/${reference.fullPath}`;

export function auditPage(pathname = window.location.hash.slice(1).split('?')[0]) {
    return Object.keys(pages).sort((a, b) => (a.match(/:/g) || []).length - (b.match(/:/g) || []).length || b.length - a.length).find(path => matchPath({ path, end: true }, pathname)) || '';
}
export function storageStatus(error) {
    if (!error) return 200;
    return ({ 'storage/unauthorized': 403, 'storage/unauthenticated': 401, 'storage/object-not-found': 404, 'storage/canceled': 499, 'storage/quota-exceeded': 429 })[error.code] || 500;
}
export async function sendStorageReport(reference, api, page, started, error) {
    if (!page) { message.warning('此页面未登记文件操作，审计未上报，请联系管理员。'); return; }
    const report = { event_id: uuid(), interface: api, page, object: reference.fullPath, bucket: reference.bucket,
        status: storageStatus(error), duration_ms: Math.max(0, Date.now() - started), error_code: error?.code || '' };
    // Retry only transient transport/server errors. A successful upload remains usable.
    for (let attempt = 0; attempt < 3; attempt += 1) {
        try { await reportExternalOperation(report); return; }
        catch (failure) {
            if (attempt === 2 || (failure.response?.status >= 400 && failure.response?.status < 500)) {
                message.warning('文件操作已完成，但审计上报失败，请联系管理员。'); return;
            }
            await new Promise(resolve => setTimeout(resolve, (attempt + 1) * 500));
        }
    }
}
export function uploadBytesResumable(reference, file, metadata) {
    const started = Date.now(), page = auditPage();
    const key = objectKey(reference);
    uploadPages.set(key, page);
    if (uploadPages.size > 256) uploadPages.delete(uploadPages.keys().next().value);
    let task;
    try { task = upload(reference, file, metadata); }
    catch (error) { uploadPages.delete(key); void sendStorageReport(reference, 'storage.upload', page, started, error); throw error; }
    task.on('state_changed', undefined,
        error => { uploadPages.delete(key); void sendStorageReport(reference, 'storage.upload', page, started, error); },
        () => { void sendStorageReport(reference, 'storage.upload', page, started); });
    return task;
}
export async function getDownloadURL(reference) {
    const started = Date.now(), key = objectKey(reference), page = uploadPages.get(key) || auditPage();
    try {
        const result = await downloadURL(reference);
        await sendStorageReport(reference, 'storage.download-url', page, started);
        return result;
    } catch (error) { await sendStorageReport(reference, 'storage.download-url', page, started, error); throw error; }
    finally { uploadPages.delete(key); }
}
